<div class="wrapper--spacing-horizontal wrapper--spacing-vertical">
  <ul class="info-header">
    <li *ngIf="customer$ | async as customer">
      <label class="text-bold">{{ 'feed-advice-report.farmcompany' | translate }}:</label>
      <label class="wide-label">
        {{ customer?.name }}, {{ customer?.street }} {{ customer?.houseNumber }}
        {{ customer?.houseNumberAddition }},
        {{ customer?.city }}
      </label>
    </li>
    <li *ngIf="customer$ | async as customer">
      <label class="text-bold">{{ 'feed-advice-report.customernr' | translate }}:</label>
      <label>{{ customer?.externalId }}</label>
    </li>
    <li *ngIf="location$ | async as location">
      <label class="text-bold">{{ 'feed-advice-report.location' | translate }}:</label>
      <label class="wide-label">
        {{ location?.name }}, {{ location?.street }} {{ location?.houseNumber }}
        {{ location?.houseNumberAddition }},
        {{ location?.city }}
      </label>
    </li>
  </ul>
</div>
<div class="wrapper--spacing-horizontal">
  <table>
    <thead>
      <tr>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.start-weight' | translate }} (kg)
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.piglet-price' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.slaughtered-weight' | translate }} (kg)
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.revenue' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.feed-packet-price' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.occupancy-rate' | translate }} (%)
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.amount' | translate }}
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.growth' | translate }}
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.feed-conversion' | translate }}
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.feed-price' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.final-difference-delivered' | translate }}
          ({{ currencySymbol }})
        </th>
        <th colspan="2">
          {{
            'feed-profit.detail.quick-simulation.table.final-difference-average-present-grow-finisher'
              | translate
          }}
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.final-difference-year' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.feed-profit-delivered' | translate }} ({{
            currencySymbol
          }})
        </th>
        <th colspan="2">
          {{ 'feed-profit.detail.quick-simulation.table.feed-profit-average' | translate }} ({{
            currencySymbol
          }})
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <ng-container
          *ngIf="
            row !== null &&
            row !== undefined &&
            getComparisonRow() !== null &&
            getComparisonRow() !== undefined
          "
        >
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.startWeight, getComparisonRow().startWeight, '1.01-01'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.pigletPrice, getComparisonRow().pigletPrice, '1.02-02'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(
                row.slaughteredWeightInKg,
                getComparisonRow().slaughteredWeightInKg,
                '1.01-01'
              ),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.revenuePerKg, getComparisonRow().revenuePerKg, '1.02-02'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.feedPacketPrice, getComparisonRow().feedPacketPrice, '1.02-02'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.occupancyRate, getComparisonRow().occupancyRate, '1.01-01'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.amount, getComparisonRow().amount, '1.01-02'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.growth, getComparisonRow().growth, '1.00-00'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.feedConversion, getComparisonRow().feedConversion, '1.01-02'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.feedPrice, getComparisonRow().feedPrice, '1.03-03'),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(
                row.finalDifferenceDelivered,
                getComparisonRow().finalDifferenceDelivered,
                '1.02-02'
              ),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(
                row.finalDifferenceAveragePresentGrowFinisher,
                getComparisonRow().finalDifferenceAveragePresentGrowFinisher,
                '1.02-02'
              ),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(
                row.finalDifferenceYear,
                getComparisonRow().finalDifferenceYear,
                '1.02-02'
              ),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(
                row.feedProfitDelivered,
                getComparisonRow().feedProfitDelivered,
                '1.02-02'
              ),
            }"
          ></ng-container>
          <ng-container
            [ngTemplateOutlet]="quicksimulationRow"
            [ngTemplateOutletContext]="{
              data: getData(row.feedProfitAverage, getComparisonRow().feedProfitAverage, '1.02-02'),
            }"
          ></ng-container>
        </ng-container>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #quicksimulationRow let-data="data">
  <td class="align-right">
    {{ data.rowVal }}
  </td>
  <td>
    <span class="align-left" *ngIf="data.positive > 0" class="text-color--primary-500"> + </span>
    <span
      class="align-left"
      [ngClass]="
        data.positive > 0
          ? 'text-color--primary-500'
          : data.positive < 0
            ? 'text-color--warn-500'
            : ''
      "
    >
      {{ data.difference !== 0 ? data.difference : ('' | agrNumber: data.digitsInfo) }}
    </span>
    <br />
    <mat-icon class="align-left" *ngIf="data.positive > 0" class="text-color--primary-500"
      >arrow_upward</mat-icon
    >
    <mat-icon class="align-left" *ngIf="data.positive < 0" class="text-color--warn-500"
      >arrow_downward</mat-icon
    >
  </td>
</ng-template>
